import { useTranslation } from 'next-i18next';
const dataList = [
  {
    title: 'Please DO:',
    list: [
      'Place your affiliate link in blogs, comparison articles, or social platforms.',
      'Promote Dolphin Radar on your favorite social media channels using your unique link.',
    ],
  },
  {
    title: "Please DON'T:",
    list: [
      'Use your affiliate link on sites with adult, illegal, or harmful content.',
      'Use spammy, misleading, or deceptive tactics to drive clicks or sign-ups.',
      'Impersonate Dolphin Radar or misrepresent the product in any way.',
      'Abuse or attempt to game the affiliate program.',
    ],
  },
];
export default function GuideSucc() {
  const { t } = useTranslation('common');
  return (
    <div className="lg:py-20 py-10 bg-[#F7F6FF] lg:px-0 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="lg:text-5xl text-3xl font-bold text-gray-900 text-center mb-4">{t('Guidelines for success')}</h2>
        <p className="lg:text-lg text-base text-gray-500 text-center lg:w-[70%] w-full mx-auto">
          {t(
            ' To help you succeed and keep things fair for everyone, here are a few simple do’s and don’ts for promoting Dolphin Radar. Follow these best practices to maximize your earnings and stay compliant.'
          )}
        </p>

        <div className="lg:w-[80%] w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 lg:mt-14 mt-7">
          {dataList.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl border border-gray-200 shadow p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">{t(item.title)}</h3>
              <ul className="text-gray-700 text-base space-y-4">
                {item.list.map((item, index) => (
                  <li key={index} className="text-gray-500">
                    {index + 1}. {t(item)}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
